import {isMobile} from '@/src/shared/utils/functions'
import {Routes} from '@/src/config/routes'

export const formatPageLink = (url: string, staticPages: string[] = []) => {
  const catalogRegex = new RegExp('^/catalog/(.*)$', 'i')
  if (catalogRegex.test(url)) {
    if (isMobile()) {
      return url.replace(catalogRegex, '/catalog/?slug=$1')
    }
  }

  if (staticPages.length > 0) {
    url = Routes.static(url, staticPages)
  }

  return url
}

export const formatMenuItemsDeep = (menuItems: LayoutMenuItem[], staticPages: string[] = []): LayoutMenuItem[] => {
  return menuItems.map(item => ({
    ...item,
    ...((item.children && {children: formatMenuItemsDeep(item.children, staticPages)}) || {}),
    url: Routes.static(item.url, staticPages),
  }))
}
